import { AfterViewInit, ErrorHandler } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFa from '@angular/common/locales/fa';
import localePl from '@angular/common/locales/pl';
import localeRu from '@angular/common/locales/ru';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEl from '@angular/common/locales/el';
import localeDa from '@angular/common/locales/da';
import localeBg from '@angular/common/locales/bg';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeSq from '@angular/common/locales/sq';
import localeRo from '@angular/common/locales/ro';
import { environment } from '../environments/environment';
import { translationHelper } from '~/helpers/translation.helper';
import { environment as versioning } from '../environments/version';
import * as Sentry from '@sentry/browser';
export class SentryErrorHandler {
    constructor() { }
    handleError(error) {
        Sentry.captureException(error.originalError || error);
        throw error;
    }
}
export function provideErrorHandler() {
    console.log('ENV:', environment.production);
    if (environment.production) {
        Sentry.init({
            dsn: 'https://452e900ceafa411eaf8d5a3adc46feaf@sentry.io/1415440',
            release: 'terminal@' + versioning.version,
        });
        return new SentryErrorHandler();
    }
    else {
        return new ErrorHandler();
    }
}
export class localizationInit {
    constructor(_Localization) {
        this._Localization = _Localization;
        this.LANGCODE = 'en';
        this.LANGCODE = this._Localization.LANGCODE;
        console.log('this._Localization.LANGID', this._Localization.LANGID);
        if (this._Localization.LANGID == 2) {
            registerLocaleData(localeEn);
        }
        else if (this._Localization.LANGID == 3) {
            registerLocaleData(localeTr);
        }
        else if (this._Localization.LANGID == 6) {
            registerLocaleData(localeDe);
        }
        else if (this._Localization.LANGID == 8) {
            registerLocaleData(localeFa);
            //jalaali.loadPersian({ usePersianDigits: true });
        }
        else if (this._Localization.LANGID == 5) {
            registerLocaleData(localeRu);
            //jalaali.loadPersian({ usePersianDigits: true });
        }
        else if (this._Localization.LANGID == 12) {
            registerLocaleData(localePl);
            this.LANGCODE = 'pl';
            console.log('pl register');
        }
        else if (this._Localization.LANGID == 22) {
            registerLocaleData(localeIt);
            this.LANGCODE = 'it';
        }
        else if (this._Localization.LANGID == 14) {
            registerLocaleData(localeFr);
            this.LANGCODE = 'fr';
        }
        else if (this._Localization.LANGID == 19) {
            registerLocaleData(localeDa);
            this.LANGCODE = 'da';
        }
        else if (this._Localization.LANGID == 17) {
            registerLocaleData(localeBg);
            this.LANGCODE = 'bg';
        }
        else if (this._Localization.LANGID == 15) {
            registerLocaleData(localeEl);
            this.LANGCODE = 'el';
        }
        else if (this._Localization.LANGID == 7) {
            registerLocaleData(localeEs);
            this.LANGCODE = 'es';
        }
        else if (this._Localization.LANGID == 11) {
            registerLocaleData(localePt);
            this.LANGCODE = 'pt';
        }
        else if (this._Localization.LANGID == 16) {
            registerLocaleData(localeSq);
            this.LANGCODE = 'sq';
        }
        else if (this._Localization.LANGID == 20) {
            registerLocaleData(localeRo);
            this.LANGCODE = 'ro';
        }
        else {
            registerLocaleData(localeEn);
        }
    }
    getLanguage() {
        return this.LANGCODE;
    }
}
const ɵ0 = localizationInit => localizationInit.getLanguage();
export class AppModule {
    ngOnInit() { }
    ngAfterViewInit() { }
}
export { ɵ0 };
